const display = (value) => value || "-";

export { display };